// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { comment16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { Icon, registerIcon } from '../icon-base';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-comment': IconComment;
    }
}

/**
 * The icon component for the 'comment' icon
 */
export class IconComment extends Icon {
    public constructor() {
        super(comment16X16);
    }
}

registerIcon('icon-comment', IconComment);
export const iconCommentTag = 'nimble-icon-comment';
